import { Badge, Button } from '@mui/material';
import { memo, useState } from 'react';
import { useQueries } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import NotificationDrawer from './NotificationDrawer';

const NotificationMenu = () => {
  const axiosPrivate = useAxiosPrivate();
  const [isOpen, setIsOpen] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [{ data: count }, { data, refetch }] = useQueries([
    {
      queryKey: '/dictionary/notificationcount',
      queryFn: async function () {
        const response = await axiosPrivate.get(
          '/dictionary/notificationcount'
        );
        return response.data.data;
      },
      enabled: !hasError,
      onError: (error) => {
        setHasError(true);
      },
      retry: false,
      refetchInterval: 3 * 12000,
    },
    {
      queryKey: '/dictionary/notifications',
      queryFn: async function () {
        const response = await axiosPrivate.get('/dictionary/notifications');
        return response.data.data?.data;
      },
      enabled: !hasError,
      onError: (error) => {
        setHasError(true);
      },
      retry: false,
    },
  ]);

  const handleClick = (event) => {
    refetch();
    setIsOpen(true);
  };

  return (
    <div className='notification-menu-wrapper ml-auto'>
      <Button
        variant='base'
        size='small'
        sx={{ padding: '6px 12px' }}
        rotate='true'
        onClick={handleClick}
      >
        <Badge badgeContent={count || 0} invisible={!count} color='error'>
          <i className='bi bi-bell' />
        </Badge>
      </Button>
      <NotificationDrawer open={isOpen} setOpen={setIsOpen} data={data} />
    </div>
  );
};

export default memo(NotificationMenu);
